import { goToNextPage } from "@ignitesales/neuro-application/src/actions/navigation-action-creators";
import {
  loadProductCart,
  updateProductCart,
} from "@ignitesales/neuro-application/src/actions/product-action-creators";
import { actionCompleted } from "@ignitesales/neuro-application/src/actions/question-action-creators";
import { getMessageValue } from "@ignitesales/neuro-application/src/i18n/messageUtil.mjs";
import buildPageUrl from "@ignitesales/neuro-application/src/page/buildPageUrl";
import { flatProductList } from "@ignitesales/neuro-application/src/util/productUtil.mjs";
import classnames from "classnames";
import React, { useContext, useEffect, useRef, useState } from "react";
import { FormattedHTMLMessage, FormattedMessage, useIntl } from "react-intl";
import { connect } from "react-redux";
import { Slide, toast } from "react-toastify";
import GuideContext from '../../GuideContext';
import { ActionService } from '../../utils/guideAPI/ActionService.mjs';
import GuideApiService from "../../utils/guideAPI/GuideApiService.mjs";
import ContactCart from "../ContactCart";
import LabelWithRuleEvaluation from "../LabelWithRuleEvaluation";
import MessageWithRuleEvaluation from "../MessageWithRuleEvaluation";
import Product from "../Product";
import ShareViaEmailModal from "../ShareViaEmailModal";
import ShareViaSmsModal from "../ShareViaSmsModal";
import ConfirmDeleteModal from "../confirmDeleteModal";

function SummaryPage(props) {
  const {
    classname,
    products,
    actionCompleted,
    detailsUrl,
    previousPageClicked,
    answers,
    addToCartClicked,
    removeFromCartClicked,
    productCart = new Set(),
    user
  } = props;
  const { isBusinessGuide } = useContext(GuideContext);
  const intl = useIntl();
  const pageCssBEM = "summaryPage";
  const classes = classnames(
    pageCssBEM,
    { [`${ pageCssBEM }__business`]: isBusinessGuide },
    classname
  );

  const [startAnimation, setStartAnimation] = useState(false);

  useEffect(() => setStartAnimation(true), [startAnimation]);

  const [smsOpen, setSmsOpen] = useState(false);
  const [shareViaEmailOpen, setShareViaEmailOpen] = useState(false);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);
  const [bottomScrolled, setBottomScrolled] = useState(false);
  const [showContactCart, setShowContactCart] = useState(false);
  const [localGoalCart, setLocalGoalCart] = useState(answers?.goalsSavedToCart?.value || []);
  const [localGoalNames, setLocalGoalNames] = useState(answers?.goalNamesSavedToCart?.value || []);
  const [productToDelete, setProductToDelete] = useState(null);
  const [showCart, setShowCart] = useState(true);

  const summaryPage = useRef(null);

  const scroll = (direction) => {
    const whereToScroll = direction === "down"
      ? (document.querySelector(".pageContainer").scrollTop + 400)
      : 0;
    setScrollTop(whereToScroll);
  }

  const pageContainer = document.querySelector(".pageContainer");

  useEffect(() => {
    pageContainer.scrollTo({
      top: scrollTop,
      behavior: "smooth"
    });
  }, [scrollTop, pageContainer]);

  const throttle = (fn, wait) => {
    var time = Date.now();
    return function () {
      if ((time + wait - Date.now()) < 0) {
        fn();
        time = Date.now();
      }
    }
  }

  const windowScrollHandler = () => {
    const bottomScrolled = (pageContainer.scrollTop + pageContainer.offsetHeight) >= pageContainer.scrollHeight
    setBottomScrolled(bottomScrolled);
    if (bottomScrolled) { setScrollTop(pageContainer.scrollHeight) }
  }

  useEffect(() => {
    pageContainer.addEventListener("scroll", windowScrollHandler, { passive: true });
    return () => {
      pageContainer.removeEventListener("scroll", windowScrollHandler, { passive: true });
    }
  }, [pageContainer]);

  // @TODO Should Remove?
  const [width, setWidth] = useState(window.innerWidth);
  const handleResize = () => {
    setWidth(window.innerWidth);
  };

  window.addEventListener("resize", handleResize);
  // END TODO

  // @TODO Should Remove?
  const handleBack = () => {
    const pageContainter = document.getElementsByClassName("pageContainer");
    pageContainter[0].scrollTop = 0;
    previousPageClicked();
  };
  // END TODO

  const accountTypes = [
    "feeAdvisory",
    "cashManagement",
    "personalLoans",
    "homeLoanLine",
    "financialPlanning",
    "trustServices",
    "mortgage",
    "retirement",
    "investmentAdvisoryServices",
  ];

  //@TODO should only be for consumer?
  const showOtherAccountsLabel = () => {
    return LabelWithRuleEvaluation({ idArray: accountTypes, answers: answers });
  };
  // END TODO

  const svgPath = getMessageValue(intl.locale, `${ pageCssBEM }.icon`);

  const onPrintClick = () => {
    actionCompleted("printFormClicked");
    if (detailsUrl) {
      window.location.href = detailsUrl;
    }
  };

  const submitSuccessToast = () => {
    toast.success(getMessageValue(intl.locale, 'cart.submit.toast.successText'), {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      transition: Slide
    })
  }

  const saveAnswerWithValue = async (key, value) => {
    await ignite.answerService.saveAnswer({
      appkey: key,
      value,
      timestamp: new Date()
    });
  }

  const isProductId = (id) => /^\d+$/.test(id);

  const onCartDeleteClick = (productId) => {
    setProductToDelete(productId)
    setShowContactCart(false);
    setConfirmDeleteOpen(true);
  }

  const onCartDeleteConfirm = () => {
    setConfirmDeleteOpen(false);
    if (getCartCount() > 1) setShowContactCart(true);
    if (isProductId(productToDelete)) {
      toggleProductInCart(productToDelete);
    } else {
      toggleGoalInCart(productToDelete);
    }
    setProductToDelete(null);
    actionCompleted("deleteCartItemClicked");
  }

  const onCartDeleteClose = () => {
    setConfirmDeleteOpen(false);
    setShowContactCart(true);
  }

  const handleCartOpen = () => {
    setShowContactCart(true);
    actionCompleted("openCartClicked");
  };

  const onContactFormSubmissionAction = async () => {
    try {
      const actions = await ActionService.getActionsByTriggerType('contactSubmit');
      for(let action of actions){
          for(let trigger of action.triggers){
              if(trigger.type == 'contactSubmit'){
                const customConfigs = {};
                const extractActionParams=  await ActionService.extractActionParams(action, user, customConfigs?.guideActionServiceMapper)
                const result = await ActionService.triggerAction(action, trigger?._id, extractActionParams)
                console.log('result', JSON.stringify(result));
                console.log('action ' + action.name + ' was triggered');
              }
          }
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleCartSubmit = async () => {
    await onContactFormSubmissionAction();
    setShowContactCart(false);
    actionCompleted("submitCartClicked");
    submitSuccessToast();
  };

  const getCartCount = () => {
    return 0 + productCart.size + localGoalCart.length;
  }

  const toggleGoalInCart = (goalName) => {
    const goalNameString = getMessageValue(intl.locale, `${ goalName }.name`);
    let newLocalGoalCart = [];
    let newLocalGoalNames = [];

    if (localGoalCart.includes(goalName)) {
      newLocalGoalCart = localGoalCart.filter(goal => goal != goalName);
      newLocalGoalNames = localGoalNames.filter(name => name != goalNameString);
      actionCompleted("removeGoalFromCartClicked");
    } else {
      newLocalGoalCart = [...localGoalCart, goalName];
      newLocalGoalNames = [...localGoalNames, goalNameString];
      actionCompleted("addGoalToCartClicked");
    }

    setLocalGoalCart(newLocalGoalCart)
    setLocalGoalNames(newLocalGoalNames);
    saveAnswerWithValue("goalsSavedToCart", newLocalGoalCart);
    saveAnswerWithValue("goalNamesSavedToCart", newLocalGoalNames);
  }

  const renderOtherAccounts = (isForCart = false) => {
    let otherAccounts = [];
    const sourceAccounts = isForCart ? localGoalCart : accountTypes;

    sourceAccounts.forEach((id) => {
      let checkbox = (
        <MessageWithRuleEvaluation id={id} key={id}>
          <label key={id}>
            {isForCart ?
              <div className="cartItem">
                <div className="cartGoalName"><FormattedHTMLMessage id={`${ id }.name`} /></div><button className="btn removeButton" onClick={() => onCartDeleteClick(id)}><i class="icon fa fa-trash-o"></i></button>
              </div>
              :
              <>
                <input type="checkbox" id={id} value={id} checked={localGoalCart.includes(id)} onClick={() => toggleGoalInCart(id)} />
                <FormattedHTMLMessage id={id} />
              </>
            }
          </label>
        </MessageWithRuleEvaluation>
      );
      otherAccounts.push(checkbox);
    });

    if (isForCart && otherAccounts.length == 0) otherAccounts.push(<FormattedHTMLMessage id="cart.empty.goals" />)

    return otherAccounts;
  }

  const productIsInCart = (productId) => {
    return productCart.has(productId.toString());
  }

  const toggleProductInCart = async (productId) => {
    if (productIsInCart(productId)) {
      actionCompleted("removeProductFromCartClicked");
      await removeFromCartClicked(productCart, productId);
    } else {
      actionCompleted("addProductToCartClicked");
      await addToCartClicked(productCart, productId);
    }
  }

  const productList =
    (products.groups || [])
      .map((g) => {
        return flatProductList(g);
      })
      .flat() || [];

  return (
    <div className={classes}>
      <div className={`${ pageCssBEM }__blueCorner`}></div>
      <div className={`${ pageCssBEM }__headerContact`}>
        <button
          className="btn btn--large btn--filled"
          onClick={handleCartOpen}
        >
          <div className="cart-button-container">
            <div className="cart-button-icon">
              <span class="material-symbols-outlined">shopping_cart</span> <span className="cart-count">{getCartCount()}</span>
            </div>
            <div className="cart-button-text">
              <FormattedMessage id="cart.label" />
            </div>
          </div>
        </button>
      </div>
      <div ref={summaryPage} className={`${ pageCssBEM }__body`}>
        {!bottomScrolled && (
          <div onClick={() => scroll("down")} className="scrollButton scrollDown">
            <div className="triangle"></div>
          </div>
        )}
        {bottomScrolled && (
          <div onClick={() => scroll("up")} className="scrollButton scrollUp">
            <div className="triangle"></div>
          </div>
        )}
        <div className={`${ pageCssBEM }__header`}>
          <FormattedMessage id={pageCssBEM} tagName="h1" />
          <div className={`${ pageCssBEM }__productHeader ${ isBusinessGuide ? '' : 'consumer' }`}>
            <div className={`${ pageCssBEM }__headerSocial py-3`}>
              <button className={`btn btn--small ${ isBusinessGuide ? 'btn--outline' : '' }`} onClick={onPrintClick}>
                <i className="lni-printer" role="img" aria-label="Printer" />
                <FormattedMessage id="summary.actions.print" tagName="span" />
              </button>
              <button className={`btn btn--small ${ isBusinessGuide ? 'btn--outline' : '' }`} onClick={() => setSmsOpen(true)}>
                <i
                  className="lni-mobile"
                  role="img"
                  aria-label="Mobile Phone"
                />
                <FormattedMessage id="summary.actions.text" tagName="span" />
              </button>
              <button
                className={`btn btn--small ${ isBusinessGuide ? 'btn--outline' : '' }`}
                onClick={() => {
                  setShareViaEmailOpen(true);
                }}
              >
                <i className="lni-envelope" role="img" aria-label="Envelope" />
                <FormattedMessage id="summary.actions.email" tagName="span" />
              </button>
            </div>
          </div>
        </div>
        <div className={`${ pageCssBEM }__content`}>
          <div className={`${ pageCssBEM }__products`}>
            {productList.map((product) => {
              return (
                <Product
                  product={product}
                  key={product.id}
                  actionCompleted={actionCompleted}
                  toggleProductInCart={toggleProductInCart}
                  productIsInCart={productIsInCart(product.id)}
                />
              )
            })}
          </div>
          {!isBusinessGuide && (
            <div className={`${ pageCssBEM }__otherProducts`}>
              <div className="product">
                <div className="product__header consumer">
                  <div></div>
                  <h1>
                    {showOtherAccountsLabel() && (
                      <FormattedMessage id="otherAccounts" tagName="span" />
                    )}
                  </h1>
                </div>
                <div className="list-action-wrapper">
                  <ul>{renderOtherAccounts()}</ul>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="pageNavigation">
        <button className="pageNavigation__prev btn" onClick={handleBack}>
          <span className="d-flex justify-content-center align-items-center">
            <i className="fa fa-angle-left" />
            <span>Back</span>
          </span>
        </button>
      </div>
      <ShareViaEmailModal
        active={shareViaEmailOpen}
        onClose={() => {
          setShareViaEmailOpen(false);
        }}
      />
      <ShareViaSmsModal
        active={smsOpen}
        onClose={() => {
          setSmsOpen(false);
        }}
      />
      <ConfirmDeleteModal
        active={confirmDeleteOpen}
        onClose={() => onCartDeleteClose()}
        onSubmit={() => onCartDeleteConfirm()}
        productToDelete={productToDelete}
      />
      <ContactCart
        show={showContactCart}
        onClose={() => setShowContactCart(false)}
        onSubmit={handleCartSubmit}
        productCart={productCart}
        onCartDelete={onCartDeleteClick}
        renderOtherAccounts={renderOtherAccounts}
        showCart={showCart}
        setShowCart={setShowCart}
      />
    </div>
  );
}

export default connect(
  (state) => {
    const { progress: { total = 0 } = {} } = state;
    const contactLead = state.contactMe || { isProcessing: false, contactLead: null };

    const answers = state.answers || {};
    const products = state.products || {};
    const productCart = state.productCart || answers?.productsSavedToCart?.value;
    const user = state.user || {};
    const detailsUrl = buildPageUrl({
      type: "details",
      uuid: user.uuid,
    });

    GuideApiService.useLead(contactLead);
    GuideApiService.useUser(user);
    // TODO: figure out a better way to handle domain
    const domain = window?.location?.href?.includes('anbtxconsumerchecking') ? 'anbtxconsumerchecking' : 'anbtxbusiness';
    GuideApiService.useGuide({ domain });

        return {
      answers,
      products,
      contactLead,
      productCart: Array.isArray(productCart)
        ? new Set(productCart)
        : productCart,
      user,
      detailsUrl,
    };
  },
  (dispatch) => {
    return {
      loadProducts: () => {
        dispatch(loadProductCart());
      },
      addToCartClicked: (products, productId) => {
        dispatch(updateProductCart(products, productId));
      },
      removeFromCartClicked: (products, productId) => {
        dispatch(updateProductCart(products, productId, true));
      },
      actionCompleted: (actionName, productId, value, append) => {
        dispatch(actionCompleted({ actionName, productId, value, append }));
      },
      previousPageClicked: () => {
        dispatch(goToNextPage(true));
      },
      handleCartSubmit: (contactLead) => {
        dispatch(contactLeadUpdate({ contactLead }));
      },
    };
  }
)(SummaryPage);
